export const female_headwear = [
  //An array of each Female Headwear ID, Atlas, and name. There are ??.
  /* Headwear that's available in-game from Barbershop. */
  {
    id: "headwear0",
    atlas: "",
    name: "No headwear" //Show name in textbox.
  },
  {
    id: "headwear1",
    atlas: "atlas16",
    name: "Combat armor helmet" /* Combat armor */
  }
  // {
  //   id: 'headwear2',
  //   atlas: 'atlas16',
  //   name: 'Cat ears',
  // },
  // {
  //   id: 'headwear3',
  //   atlas: 'atlas16',
  //   name: 'Baseball cap' /* Baseball uniform */
  // },
  // {
  //   id: 'headwear4',
  //   atlas: 'atlas16',
  //   name: 'Aviator cap',
  //   disable_hair: 1
  // },
  // {
  //   id: 'headwear5',
  //   atlas: 'atlas16',
  //   name: 'Shower cap',
  //   disable_hair: 1
  // },
  // {
  //   id: 'headwear6',
  //   atlas: 'atlas16',
  //   name: 'Wasteland darklight cowl', /* Wasteland gear */
  //   disable_hair: 1,
  //   disable_beard: 1,
  //   disable_feature: 1
  // },
  // {
  //   id: 'headwear7',
  //   atlas: 'atlas16',
  //   name: 'Hard hat', //Engineer outfit
  // },
  // {
  //   id: 'headwear8',
  //   atlas: 'atlas16',
  //   name: 'Elf hat' /* Elf outfit */
  // },
  // {
  //   id: 'headwea9',
  //   atlas: 'atlas16',
  //   name: 'Mascot head',
  //   disable_hair: 1
  // },
  // {
  //   id: 'headwear10',
  //   atlas: 'atlas16',
  //   name: 'Sailor hat' /* Lifeguard outfit */
  // },
  // {
  //   id: 'headwear11',
  //   atlas: 'atlas16',
  //   name: 'Surgery bandages',
  //   disable_hair: 1,
  //   disable_beard: 1,
  //   disable_feature: 1
  // },
  // {
  //   id: 'headwear12',
  //   atlas: 'atlas16',
  //   name: 'Radiation suit helmet', /* Radiation suit */
  //   disable_hair: .5
  // },
  // {
  //   id: 'headwear13',
  //   atlas: 'atlas16',
  //   name: 'Military helmet' /* Military fatigues */
  // },
  // {
  //   id: 'headwear14',
  //   atlas: 'atlas16',
  //   name: 'Metal helmet' /* Metal armor */
  // },
  // {
  //   id: 'headwear15',
  //   atlas: 'atlas16',
  //   name: 'Laurel wreath' /* Republic robes */
  // },
  // {
  //   id: 'headwear16',
  //   atlas: 'atlas16',
  //   name: 'Ghost costume', /* Ghost costume */
  //   disable_hair: 1,
  //   disable_beard: 1,
  //   disable_feature: 1
  // },

  // {
  //   id: 'headwear17',
  //   atlas: 'atlas17',
  //   name: 'Party hat'
  // },
  // {
  //   id: 'headwear?',
  //   atlas: 'atlas?',
  //   name: 'T-45 helmet', /* T-45 power armor */
  //   disable_hair: 1,
  //   disable_beard: 1,
  //   disable_feature: 1
  // },
  // {
  //   id: 'headwear?',
  //   atlas: 'atlas?',
  //   name: 'T-51 helmet', /* T-51 power armor */
  //   disable_hair: 1,
  //   disable_beard: 1,
  //   disable_feature: 1
  // },
  // {
  //   id: 'headwear?',
  //   atlas: 'atlas?',
  //   name: 'T-60 helmet', /* T-60 power armor */
  //   disable_hair: 1,
  //   disable_beard: 1,
  //   disable_feature: 1
  // },
  // {
  //   id: 'headwear?',
  //   atlas: 'atlas?',
  //   name: 'X-01 Mk VI helmet', /* X-01 Mk VI power armor */
  //   disable_hair: 1,
  //   disable_beard: 1,
  //   disable_feature: 1
  // },
  // {
  //   id: 'headwear21',
  //   atlas: 'atlas17',
  //   name: 'Flower bonnet'
  // },
  // {
  //   id: 'headwear22',
  //   atlas: 'atlas17',
  //   name: 'Swimcap and goggles', /* Swimsuit outfit */
  //   disable_hair: 1
  // },
  // {
  //   id: 'headwear23',
  //   atlas: 'atlas17',
  //   name: 'Skeleton mask', /* Skeleton costume */
  //   disable_hair: 1,
  //   disable_beard: 1,
  //   disable_feature: 1
  // },
];
